import React, { PropTypes } from 'react';
import { Meta } from 'common/components/meta';

const PagerMeta = ({ page, meta = [], ...rest }) => {
  /* only set 'robots' tag based on page if there's no previous definition */
  const currentRobots = meta.find(m => m.name == 'robots');
  const pagerRobots = page === 0 || page === 1
    ? { name: 'robots', content: 'index,follow' }
    : { name: 'robots', content: 'noindex,follow' };
  const pageMeta = currentRobots? meta : [pagerRobots, ...meta];

  return (<Meta
    meta={pageMeta}
    {...rest}
  />);
};

PagerMeta.propTypes = {
  page: PropTypes.number,
  meta: PropTypes.any,
};

export default PagerMeta;



// WEBPACK FOOTER //
// ./common/components/pager_meta.jsx